<div class="timeline-container" *ngIf="dealTimeline && dealTimeline.markers && dealTimeline.markers.length > 0">
  <div class="dot-container">
    <span class="line"></span>
    <span class="marker" *ngFor="let marker of dealTimeline.markers" 
      [ngStyle]="getMarkerStyles(marker)"
      [title]="marker.tooltip"
    >
    </span>
    <span class="current" *ngIf="dealTimeline.current"
      [ngStyle]="{ 'margin-left': dealTimeline.current.xPos + '%' }"
      [title]="dealTimeline.current.tooltip"
    ></span>
  </div>
</div>